import React, { useEffect } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
// redux
import { useSelector, useDispatch } from "react-redux";
import { getLost } from "./redux/actions/LostActions.js";
import { getFound } from "./redux/actions/FoundActions.js";
import { getLostHistory } from "./redux/actions/LostHistoryActions.js";
import { getFoundHistory } from "./redux/actions/FoundHistoryActions.js";
import { getClaims } from "./redux/actions/ClaimActions.js";
import { getUsers } from "./redux/actions/UserActions.js";
// other
import { toast } from "react-toastify";
// pages
import LostListPage from "views/LostListPage/LostListPage.js";
import LostDetailPage from "views/LostDetailPage/LostDetailPage.js";
import FoundListPage from "views/FoundListPage/FoundListPage.js";
import FoundDetailPage from "views/FoundDetailPage/FoundDetailPage.js";
import LostHistoryListPage from "views/LostHistoryListPage/LostHistoryListPage.js";
import LostHistoryDetailPage from "views/LostHistoryDetailPage/LostHistoryDetailPage.js";
import FoundHistoryListPage from "views/FoundHistoryListPage/FoundHistoryListPage.js";
import FoundHistoryDetailPage from "views/FoundHistoryDetailPage/FoundHistoryDetailPage.js";
import ClaimListPage from "views/ClaimListPage/ClaimListPage.js";
import ClaimDetailPage from "views/ClaimDetailPage/ClaimDetailPage.js";
import LoginPage from "views/LoginPage/LoginPage.js";
import SignupPage from "views/SignupPage/SignupPage.js";
import UserListPage from "views/UserListPage/UserListPage.js";
import UserDetailPage from "views/UserDetailPage/UserDetailPage.js";
import EditProfilePage from "views/EditProfilePage/EditProfilePage";
import HomePage from "views/HomePage/HomePage.js";

toast.configure();

const PrivateRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      auth.isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect to="/users/login" />
      )
    }
  />
);

const AdminRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      auth.isAuthenticated && auth.user.isAdmin ? (
        <Component {...props} />
      ) : (
        <Redirect to="/users/login" />
      )
    }
  />
);

function App() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    getLost(dispatch);
    getFound(dispatch);
    getLostHistory(dispatch);
    getFoundHistory(dispatch);
    if (auth.isAuthenticated) {
      getUsers(dispatch);
      getClaims(dispatch);
    }
  }, [auth, dispatch]);

  return (
    <Switch>
      <Route exact path="/lostitems" component={LostListPage} />
      <PrivateRoute
        path="/lostitems/:id"
        component={LostDetailPage}
        auth={auth}
      />
      <Route exact path="/founditems" component={FoundListPage} />
      <PrivateRoute
        path="/founditems/:id"
        component={FoundDetailPage}
        auth={auth}
      />
      <PrivateRoute
        exact
        path="/lostitemhistory"
        component={LostHistoryListPage}
        auth={auth}
      />
      <PrivateRoute
        path="/lostitemhistory/:id"
        component={LostHistoryDetailPage}
        auth={auth}
      />
      <PrivateRoute
        exact
        path="/founditemhistory"
        component={FoundHistoryListPage}
        auth={auth}
      />
      <PrivateRoute
        path="/founditemhistory/:id"
        component={FoundHistoryDetailPage}
        auth={auth}
      />
      <AdminRoute
        exact
        path="/claimrequests"
        component={ClaimListPage}
        auth={auth}
      />
      <AdminRoute
        path="/claimrequests/:claimerUsername&:foundItemId"
        component={ClaimDetailPage}
        auth={auth}
      />
      <AdminRoute exact path="/users" component={UserListPage} auth={auth} />
      <PrivateRoute
        exact
        path="/users/editprofile"
        component={EditProfilePage}
        auth={auth}
      />
      <Route exact path="/users/login" component={LoginPage} />
      <Route exact path="/users/signup" component={SignupPage} />
      <PrivateRoute
        path="/users/:username"
        component={UserDetailPage}
        auth={auth}
      />
      <Route path="/" component={HomePage} />
    </Switch>
  );
}

export default App;
